// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { memo, useEffect, useRef } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';
import { Bounds } from '../../types/map-layer';

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

type Props = {
  bounds: Bounds;
  showDraw: boolean;
  onChange: (bounds: Bounds) => void;
};

const mapOptions = {
  center: { lat: 40, lng: -10 },
  zoom: 2,
};

const styles = {
  strokeColor: '#0A1D31',
  fillColor: '#E4EFFD',
  fillOpacity: 0.7,
  strokeWeight: 2,
  zIndex: 1,
};

const Map = (props: Props): JSX.Element => {
  const ref = useRef();

  const initializeMapDraw = (): void => {
    const map = new window.google.maps.Map(ref.current, mapOptions);
    const drawingManager = new window.google.maps.drawing.DrawingManager({
      drawingMode: window.google.maps.drawing.OverlayType.MARKER,
      drawingControl: true,
      drawingControlOptions: {
        drawingModes: [
          window.google.maps.drawing.OverlayType.RECTANGLE,
        ],
      },
      markerOptions: {
        icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png',
      },
      rectangleOptions: {
        ...styles,
        // clickable: false,
        editable: true,
        active: true
      }
    });

    window.google.maps.event.addListener(drawingManager, 'rectanglecomplete', (rectangle) => {
      props.onChange(rectangle.getBounds().toJSON() as Bounds);
    });
    drawingManager.setMap(map);
  };

  const initializeMap = (): void => {
    const map = new window.google.maps.Map(ref.current, mapOptions);
    new window.google.maps.Rectangle({
      ...styles,
      map,
      bounds: props.bounds,
    });
  };

  useEffect(() => {
    if (!props.showDraw) {
      initializeMap();
    } else {
      initializeMapDraw();
    }
  }, [props.showDraw]);

  return <div ref={ref} id="map" style={{ width: '806px', height: '488px' }} />;
};

export const MapWrapper = memo((props: Props): JSX.Element => {
  return <Wrapper apiKey={API_KEY} libraries={['drawing']}>
    <Map { ...props } />
  </Wrapper>;
});
